'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'bulldozer';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e655';
var svgPathData = ['M32 400c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-256 0c-44.2 0-80 35.8-80 80zM64 224l0 74.8c14.5-6.9 30.8-10.8 48-10.8l256 0c17.2 0 33.5 3.9 48 10.8l0-42.8c0-17.7-14.3-32-32-32l-111.7 0c-.2 0-.4 0-.7 0L64 224zm80 176a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M80 64l92.2 0c6.1 0 11.6 3.4 14.3 8.8L246.1 192 64 192 64 80c0-8.8 7.2-16 16-16zM32 80l0 112 0 16 0 16 0 97.6C12.2 341.8 0 369.5 0 400c0 61.9 50.1 112 112 112l256 0c61.9 0 112-50.1 112-112c0-23.8-7.4-45.9-20.1-64l68.1 0 0 40.8c0 18.7 6.6 36.8 18.5 51.2l65.2 78.2c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5l-65.2-78.2c-7.2-8.6-11.1-19.5-11.1-30.7l0-113.7c0-11.2 3.9-22.1 11.1-30.7l65.2-78.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L546.5 212c-12 14.4-18.5 32.5-18.5 51.2l0 40.8-80 0 0-48c0-35.3-28.7-64-64-64l-16 0 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-54.1 0L215.2 58.5C207 42.3 190.4 32 172.2 32L80 32C53.5 32 32 53.5 32 80zM64 224l207.7 0c.2 0 .4 0 .7 0L384 224c17.7 0 32 14.3 32 32l0 42.8c-14.5-6.9-30.8-10.8-48-10.8l-256 0c-17.2 0-33.5 3.9-48 10.8L64 224zm48 96l256 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-256 0c-44.2 0-80-35.8-80-80s35.8-80 80-80zm32 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBulldozer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;